import React, { useEffect, useState } from 'react';
import { BrowserRouter  as Router, Routes, Route } from 'react-router-dom';
import { io } from 'socket.io-client';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import Login from './pages/Login';
import Register from './pages/Register';
//import LabDashboard from './pages/LabDashboard';
// import StudentLogs from './pages/StudentLogs';
import AdminDashboard from './pages/AdminDashboard'; 
import Schedule from './pages/Schedule';
// import Layout from './components/Layout';
import LayoutDesign from './pages/LayoutDesign';
import StudentDashboard from './pages/StudentDashboard';
import AssistantDashboard from './pages/AssistantDashboard';
import SessionDetails from './pages/SessionDetails';
import AssistantSessionDetails from './pages/AssistantSessionDetails';
import ManageStudent from './pages/ManageStudent';
import SessionHistory from './pages/SessionHistory';
import Forbidden from './pages/Forbidden';
import StudentDetails from './pages/StudentDetails';
import ProtectedRoute from './components/ProtectedRoute';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import { Box } from '@mui/material';

const App = () => {
   const [socket, setSocket] = useState(null);
   const [sessionEvents, setSessionEvents] = useState([]);
   useEffect(() => {
    const newSocket = io("https://open-lab-management-system-backend.onrender.com", {
        transports: ["websocket", "polling"], 
    });

    newSocket.on("connect", () => {

        setSocket(newSocket); 
    });

    newSocket.on("connect_error", (err) => {
        console.error("Socket connect_error:", err.message || err);
    });

    return () => {
        newSocket.disconnect();
    };
}, []);

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2', 
    },
    secondary: {
      main: '#9c27b0',
    },
    background: {
      default: '#f5f5f5' 
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', 
          borderRadius: '8px',
        },
      },
    },
  },
});

  

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
    <Router>
      <Navbar/>
      <div className="main">
      <Box sx={{ mt: 3 }}></Box>  
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* <Route path="/dashboard" element={<LabDashboard />} /> */}
        {/* <Route path="/logs" element={<StudentLogs />} /> */}
        <Route 
          path="/admin-dashboard" 
            element={
              <ProtectedRoute allowedRoles={['staff']}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
        />
        <Route 
          path="/schedule/:labId" 
          element={
            <ProtectedRoute allowedRoles={['staff']}>
              <Schedule />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/layout-design/:labId" 
          element={
            <ProtectedRoute allowedRoles={['staff']}>
              <LayoutDesign />
            </ProtectedRoute>
          } 
        />
        <Route path="/" element={<StudentDashboard socket={socket}/>} />
        <Route
          path="/assistant-dashboard"
          element={
              <ProtectedRoute allowedRoles={['assistant', 'staff']}>
                  <AssistantDashboard />
              </ProtectedRoute>
          }
        />
        <Route 
          path="/manage-students" 
          element={
            <ProtectedRoute allowedRoles={['assistant', 'staff']}>
              <ManageStudent />
            </ProtectedRoute> 
          } 
        />                     
        <Route path="/session/:sessionId" element={<SessionDetails />} />
        <Route
          path="/assistant-session/:sessionId"
          element={
              <ProtectedRoute  allowedRoles={['assistant', 'staff']}>
                  <AssistantSessionDetails socket={socket}/>
              </ProtectedRoute>
          }
        />
        <Route path="/student-details/:studentId" element={<StudentDetails />} />
        <Route path="/session-history" element={<SessionHistory />} />
        <Route path="/403" element={<Forbidden />} />
      </Routes>
      </div>
      <Footer />
    </Router>
    </ThemeProvider>
  );
};

export default App;
